import { CapacityCalculationParams } from "./type";

export function getControlledCapacity({
  nodeRequirePlayerCounts,
  nodeStandardCapacity,
  nodeUsedCapacity,
  isGolfCourse,
  bookingType,
  groupSize = 1,
  bookingWizardCapacity,
}: CapacityCalculationParams): number {
  if (bookingType === "LessonBooking") {
    return groupSize || 1;
  }

  if (!nodeRequirePlayerCounts || isGolfCourse) {
    const standardCapacity = nodeStandardCapacity || 0;
    const usedCapacity = nodeUsedCapacity || 0;

    if (bookingType === "RequestBooking") {
      return bookingWizardCapacity || 0;
    }
    return standardCapacity - usedCapacity;
  }
  return groupSize || 1;
}
